import {
  getLBSiteUnitPrice as getLBSiteUnitPriceApi,
  getCurrentPackage as getCurrentPackageApi
} from '@/api/payment3'

function getSiteMin(bills) {
  if (!bills.paymentCycle) {
    // first order
    return 1
  } else if (bills.paymentCycle === 1) {
    // Select monthly payment, the minimum is the number of seats used
    return bills.usedOperator || 0
  } else {
    // Choose to pay semi-annually or annually, the minimum is the number of seats purchased
    return bills.operatorSite || 0
  }
}
export default {
  namespaced: true,
  state: {
    LBPlan: [
      {
        billing: 1,
        discount: 0,
        showPlan: "Monthly Plan"
      },
      {
        billing: 6,
        discount: 0.1,
        showPlan: "6 Months Plan"
      },
      {
        billing: 12,
        discount: 0.17,
        showPlan: "12 Months Plan"
      }
    ],
    subscriptionName: 'LoadBroad',
    LBSiteUnitPrice: 0,
    LBPriceInfo: null,
    bills: null,
    LBNum: 1,
    LBMinNum: 1,
    billingCycle: 1,
    paymentNext: false
  },
  mutations: {
    SET_SUBSCRIPTION_NAME(state, name) {
      state.subscriptionName = name
    },
    SET_LB_SITE_UNIT_PRICE(state, price) {
      state.LBSiteUnitPrice = price
    },
    SET_LB_PRICE_INFO(state, info) {
      state.LBPriceInfo = info
    },
    SET_BILLS(state, info) {
      state.bills = info
    },
    SET_LB_NUM(state, num) {
      state.LBNum = num
    },
    SET_LB_MIN_NUM(state, num) {
      state.LBMinNum = num
    },
    SET_BILLING_CYCLE(state, cycle) {
      state.billingCycle = cycle
    },
    SET_PAYMENT_NEXT(state, status) {
      state.paymentNext = status
    }
  },
  actions: {
    updateLBNum({ commit }, num) {
      commit('SET_LB_NUM', num)
    },
    updatePaymentNext({ commit }, status) {
      commit('SET_PAYMENT_NEXT', status)
    },
    updateBillingCycle({ commit }, cycle) {
      commit('SET_BILLING_CYCLE', cycle)
    },
    _getLBSiteUnitPrice({ commit }) {
      return getLBSiteUnitPriceApi().then(res => {
        commit('SET_LB_PRICE_INFO', res.data)
        commit('SET_LB_SITE_UNIT_PRICE', res.data.operatorSiteUnitPrice)
        commit('SET_SUBSCRIPTION_NAME', res.data.subscriptionName)
        return res.data
      }).catch(error => {
        commit('SET_LB_SITE_UNIT_PRICE', 0)
        return Promise.reject(error)
      })
    },
    getLBSiteUnitPrice({ state, dispatch }, refresh) {
      if (state.LBPriceInfo && !refresh) {
        return Promise.resolve(state.LBPriceInfo)
      } else {
        return dispatch('_getLBSiteUnitPrice')
      }
    },
    _getCurrentPackageInfo({ commit }) {
      return getCurrentPackageApi().then(res => {
        commit('SET_BILLS', res.data)
        commit('SET_LB_NUM', Math.max(res.data.operatorSite, 1))
        commit('SET_BILLING_CYCLE', Math.max(res.data.paymentCycle, 1))
        commit('SET_LB_MIN_NUM', getSiteMin(res.data))
        return res.data
      }).catch(error => {
        commit('SET_BILLS', null)
        commit('SET_LB_NUM', 1)
        commit('SET_BILLING_CYCLE', 0)
        commit('SET_LB_MIN_NUM', 1)
        return Promise.reject(error)
      })
    },
    getCurrentPackageInfo({ state, dispatch }, refresh) {
      if (state.bills && !refresh) {
        return Promise.resolve(state.bills)
      } else {
        return dispatch('_getCurrentPackageInfo')
      }
    },
  },
  getters: {
    getDistanceMonth(state){
      if (state.bills && state.bills.card && state.bills.card.nextBillDate) {
        let fDate = new Date(state.bills.card.nextBillDate)
        let fyear = fDate.getFullYear()
        let fmonth = fDate.getMonth() + 1
        let fday = fDate.getDate()

        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth()+1
        let day = date.getDate()
      
        let yearToMonth = (fyear - year) * 12
        let monthToMonth = fmonth - month
        let dateToMonth = 0
        if(fday >= day){
          dateToMonth = 0
        }else{
          dateToMonth = -1
        }
        return yearToMonth + monthToMonth + dateToMonth + 1
      }
      return 1
    }
  }
}